import { useEffect } from "react";
import { $baseApi } from "@lending/lib/api";

interface PlaidIdentityAddress {
  street: string | null;
  street2: string | null;
  city: string | null;
  region: string | null;
  postal_code: string | null;
  country: string | null;
}

interface PlaidIdentity {
  first_name: string | null;
  last_name: string | null;
  address: PlaidIdentityAddress | null;
  phone_number: string | null;
  email: string | null;
  date_of_birth: string | null;
  ssn: string | null;
  ssn_last_4: string | null;
}

interface PlaidUserAccountResponse {
  identity: PlaidIdentity | null;
  request_id: string;
}

function useFetchPlaidUserAccountQuery(publicToken: string | undefined) {
  const { mutate, data, isPending, isError } = $baseApi.useMutation(
    "post",
    "/v2/lending/plaid_user_account"
  );

  useEffect(() => {
    if (publicToken) {
      mutate({ body: { public_token: publicToken } });
    }
  }, [publicToken, mutate]);

  return {
    data: data as PlaidUserAccountResponse | undefined,
    isLoading: !!publicToken && isPending,
    isError,
  };
}

export type { PlaidIdentity, PlaidIdentityAddress, PlaidUserAccountResponse };
export { useFetchPlaidUserAccountQuery };
